export const PER_ITEM_LIMIT = 20
// a hour
export const UNIPASS_EXPIRED_TIME = 3500e3
export const CONTAINER_MAX_WIDTH = 500

export const QUERY_PRE_URL = 'preUrl' as const

export const CONTACT_ADDRESS = 'contact@nervina.io'
